import { Component, OnInit, ViewChild, Inject, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MatSort, MatTableDataSource, MatRadioChange } from '@angular/material';
import * as moment from 'moment';
import { load } from '@angular/core/src/render3/instructions';
import { SiteService } from 'src/app/services/index';
import { EqBenchmarkingService } from 'src/app/services/eq-benchmarking.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/shared';
// import { $ } from 'protractor';
declare var $: any;

// declare var moment: any;

@Component({
  selector: 'app-eq-benchmarking',
  templateUrl: './eq-benchmarking.component.html',
  styleUrls: ['./eq-benchmarking.component.scss']
})

export class EqBenchmarkingComponent implements OnInit {
  
  // form: FormGroup;
  constructor( private fb: FormBuilder,
    private siteService: SiteService,
    private eqBenchmarkingService: EqBenchmarkingService,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef,
    private alertService: AlertService ) { 
    // this.form = fb.group({
    //   date: [{begin: new Date(2018, 7, 5), end: new Date(2018, 7, 25)}]
    // });
  }

  @ViewChild(MatSort) sort: MatSort;
//E/Q Step1 variable list
  //Form builder for step 1
  

  //Site Name
  selectSite: string;
  sites = [];
  siteId:string
  //E/Q plan for a day
  dayChecked = false;
  dateInputValue:Date;
  planDateRadioGroup=''
  // daySelectRadio= false;
 
  //E/Q plan for month
  monthCkecked = false;
  monthInputValue:Date;
  // monthSelectRadio=false;
  //Select Load
  loadStatus =false;
  loads_value = [];
  loadsList = [];
  selectedLoadID :string;
  selectedLoad :string;
  // setLoad:false;
  loadRadioGroup='';
  loadnameList='';
  //Select Value Stream
  processList = [];
  valueStreamStatus = false;
  selectedProcessID:string;
  selectedProcess:string;
  processnameList='';
  // setProcess=false;
  //Product Name
  productNameList =[];
  prdList : string;
  prdNameValue:string;
  //Product Quantity Table
  dateEleTable = [];
  dataSource : MatTableDataSource<any>;
  datascrLeng = null;
  displayedColumns = ['load', 'daymonth', 'quantity'];
  plannedValue :any = {};

  //Previous Trend, New Trend, Extend Button, Checkbox
  proceedNextStep=false;
  defalutTrend = 20;
  newTrend : number;
  newTrendSelect : false;
  eqTrend='';

  //Submit, Clear and Load buttons
  extendBtn : boolean = false;

//E/Q Step2 variable list

  //select date
  liveDate:Date;
  dateFormat=''

  //select load
  loadStreamRadioGroup='';
  selectedLoadStep2ID='';
  load2Status=false;
  load2nameList='';

  //select value stream
  selectedProcessStep2ID='';
  value2StreamStatus=false;
  processnameList2='';

  //Shift, Enter Actual Qty, Target Energy
  shiftNameList=[];
  actualValue:  any ={};
  quantityShiftList=[];
  loadShiftDataObj = [];
  loadRadioStatus=false;
  streamRadioStatus=false;

  //Submit, Clear and Load buttons
  canDeactiveStatus: boolean;

    
  daterange = new FormControl(new Date());
  plandate = new FormControl(new Date());
 

 
 
  ngOnInit() {
    this.getSiteDetails();
    this.fetchAllProducts();

  }

  // Step1: E/Q energy Benchmark Target Setting  All Functions

    // Site Name
    
    getSiteDetails() {
      this.siteService.getSiteDetails().subscribe(data => {
        this.sites = data;
        console.log("site",this.sites.forEach(ele =>{
          ele.siteName
        }))
      });
    }
    
    ChangeSite(event){
      console.log("site: ",event)
      this.siteId = event.value;
      this.getShifts(this.siteId);
      this.shiftNameList=[];
      this.actualValue={};
      this.loadsList=[];
      this.processList=[];
      this.getProcessAndLoadsBySiteId()
    }


    // E/Q plan for a day
   
    dayChange(event){
     
      this.dayChecked = event.source.checked;
      this.monthCkecked = false;
     
    }
    
    selectDate(event){
      this.extendBtn = false;
      this.dateEleTable = [];
      ELEMENT_DATA=this.dateEleTable
      
      this.dateEleTable.push ({
        load:this.selectedLoad,
        daymonth:(moment(new Date(event)).format('YYYY-MM-DD') ),
        quantity:""
      })
      console.log("event: ",this.dateEleTable)
      ELEMENT_DATA = this.dateEleTable;
      this.dataSource= new MatTableDataSource<any>(ELEMENT_DATA)
      
      this.dataSource.sort = this.sort;
      
      this.datascrLeng = this.dataSource.data.length;
  
    }

    // E/Q plan for month

    monthChange (event){
      this.monthCkecked = event.source.checked;
      this.dayChecked = false;

      console.log( " this.monthCkecked month: ",this.monthCkecked)
      console.log("this.dayChecked month: ",this.dayChecked)

    }

    dateChange(event){
      this.extendBtn = true;
      console.log("event date range: ",event.begin)
      console.log("event date range: ",event.end)
     
      // let date1 = moment(event.begin).format('YYYY-MM-DD');
      // let date2 = moment(event.end).format('YYYY-MM-DD');
      // console.log("date1",date1)
      let startdte = event.begin;
      let enddte = event.end;
  
      let dateRangeVal = this.dateRangeArray(startdte,enddte ) 
      this.dateEleTable = [];
      // ELEMENT_DATA=this.dateEleTable
      // this.dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA.slice())
      console.log("ELEMENT_DATA", ELEMENT_DATA)
      // this.dataSource.data=[];
      console.log ("dataSource",this.dataSource)
      dateRangeVal.forEach(ele =>{
        this.dateEleTable.push({
          load:this.selectedLoad,
          daymonth:ele,
          quantity:""
        })
  
      })
      ELEMENT_DATA = this.dateEleTable;
      // console.log("ELEMENT_DATA",ELEMENT_DATA)
  
  
      this.dataSource= new MatTableDataSource<any>(ELEMENT_DATA)
      
      this.dataSource.sort = this.sort;
      
      this.datascrLeng = this.dataSource.data.length
      console.log("dataSource.length",this.datascrLeng)
      console.log ("dataSource after",this.dataSource)
    }

    dateRangeArray(startDate:Date,endDate:Date){
      let arr = new Array();
      let dat = startDate;
      while (dat <= endDate){
        arr.push(moment(new Date(dat)).format('YYYY-MM-DD') )
        dat.setDate(dat.getDate() + 1);
        console.log("arr",arr)
      }
      console.log("arr",arr);
      return arr;
    }


  //Select Load
  
  loadChange(event){
    this.loadStatus = event.source.checked;
    this.valueStreamStatus = false

  }

  ChangeLoad(event){
    console.log("event change load: ",event)
    this.selectedLoadID = event.value
    
    this.loadsList.forEach(loadel =>{
      if(loadel.loadId == event.value ){
        console.log(loadel.name)
        this.selectedLoad  = loadel.name
      }
    })
    
    this.dateEleTable.forEach(el => {
      el.load = this.selectedLoad;
    })

  }

  getProcessAndLoadsBySiteId() {

  
    this.eqBenchmarkingService.getProcessAndLoadsBySiteId(this.siteId).subscribe(data => {
      this.loads_value = data;
      this.processList=[];
      this.loadsList=[];
      console.log("this.loads_value: ",this.loads_value)
     
      this.loads_value.forEach(ele =>{
        
       ele.loads.forEach(ld => {
       
         this.loadsList.push({
          loadId:ld.loadId,
          name:ld.name
         })
        
        
       })
      
       this.processList.push({
         name:ele.name,
         processId:ele.processId
       })
      
      })
      console.log("this.processList: ",this.processList)
     this.processList.forEach(ele =>{console.log(ele.name)})
      // console.log("load values: ",this.loadsList.forEach(ele=>{
      //   console.log(": ele ",ele.)
      // }));

    });
 

}

  //Select Value Stream

  valueStreamChange(event){
    this.valueStreamStatus = event.source.checked;
    this.loadStatus = false;
  }

  changeStreamProcess(event){
    this.selectedProcessID = event.value
    this.processList.forEach(processel =>{
      if(processel.processId == event.value ){
        this.selectedProcess = processel.name;
        console.log("this.selectedProcess: ",this.selectedProcess)

      }
      // else if(processel.name == this.selectedProcessID ){
      //   this.selectedProcess = processel.name
      // }
    })
    this.dateEleTable.forEach(el => {
      el.load = this.selectedProcess;
    })
  }

  //Product Name
  fetchAllProducts() {
    this.eqBenchmarkingService.fetchAllProducts().subscribe(res =>{
      console.log("all product: ",res.forEach(ele => {
        this.productNameList.push({
          name: ele.name
        })
       console.log (this.productNameList)
      }))
      
    })
  }

  dataSelect(event){
    console.log(event.target.value)
    this.prdNameValue = event.target.value;
  }

 
  //Product Quantity Table

  planedQuantityInput(event,id) {
    console.log("plannedQuantity: ",event,this.plannedValue,id)
    console.log("planned value: ", this.plannedValue[id])
    this.dateEleTable[id].quantity = this.plannedValue[id];
    console.log("this.dateEleTable[id].quantity: ",this.dateEleTable[id].quantity)
    console.log("this.dateEleTable[id].qu: ",this.dateEleTable)
  }

  cellSelected(event, i){
    console.log("cellSelected ",event,i)
  }

  //Previous Trend, New Trend, Extend Button, Checkbox
  copyPlanedQuantity() {
   console.log( this.plannedValue,this.datascrLeng)
  //  for(let i=0;i<this.datascrLeng;i++){
  //    this.plannedValue[i] = this.plannedValue[0];
  //    console.log(this.plannedValue[i].value)
  //    this.dateEleTable.push({
  //      quantity:this.plannedValue[0].value,
  //    })
  //  }
   this.dateEleTable.forEach((ele,i) =>{
     this.plannedValue[i]=this.plannedValue[0];
     ele.quantity = this.plannedValue[i] ;
   })
   console.log("this.dateEleTable[id] cpy ",this.dateEleTable)
  }

  proceedNextStepChange(event){
    
    this.proceedNextStep = event.checked
    console.log("event: ",this.proceedNextStep)
  }

  newTrendValue(event) {
    // this.newTrend = event.key;
    console.log(" this.newTrend: ", this.newTrend);

  }

  newLoadChange(event){
    this.newTrendSelect = event.source.checked;
  }

  //Submit, Clear and Load buttons
  submitTrendSettings(){
    this.canDeactiveStatus=true;
    console.log("data table: ",this.dateEleTable)
    let dateQs = [];
    let loadids =[];
    let productNameArry={name:''};
    this.dateEleTable.forEach(dt =>{
      dateQs.push({
        date:dt.daymonth,
        quantity:dt.quantity

      })
    })
    
    if(this.selectedLoadID != null){
      loadids=[]
      loadids.push(this.selectedLoadID)
    }
    else if(this.selectedProcessID != null){
      loadids=[]
      loadids.push(this.selectedProcessID)
    }
    else{
      loadids=[];
    }

    this.productNameList.forEach(ele =>{
      if(this.prdNameValue == ele.name)
      {
        productNameArry.name = ele.name;
      }
      else {
        productNameArry.name=this.prdNameValue;
      }
    })
    
   
    console.log("siteId: ",this.siteId)
    console.log(" productNameArry: "+"productNameArry "+ JSON.stringify(productNameArry))

    console.log("loadids: ", JSON.stringify(loadids )+" this.prdNameValue: "+JSON.stringify(this.prdNameValue))

    console.log(" dateQs: ", JSON.stringify(dateQs)+"this.newTrend: "+this.newTrend);

    let params = {
      "actualUseFromLiveData":this.proceedNextStep ,
      "dateAndQs": dateQs,
      "loadIds":loadids,
      "plannedEbyQ":this.newTrend,
      "product":productNameArry,
      "siteId": this.siteId

    } 
    console.log("params: ",JSON.stringify(params));
    this.eqBenchmarkingService.savePlanQForLoads(params).subscribe(res=>{
      console.log("res: ",res);
      if(res==true){
        this.alertService.message ="Save successfully!";
        this.alertService.showSuccess();
        this.clear();
      }
      else {
        this.alertService.message ="Failed to save!";
        this.alertService.showError();
      }
     
    })
  }

  clear(){
    this.changeDetectorRefs.detectChanges();
    
    this.dataSource.data=[];
    this.dataSource.filteredData=[];
    console.log(this.dataSource.data)
  
    
    this.selectSite="";
    this.dayChecked=false;
    
    this.extendBtn = false;
    this.monthCkecked = false;
    this.loadStatus = false;
    this.valueStreamStatus = false;
    this.selectedLoadID=null;
    this.selectedLoad="";
    this.selectedProcessID=null;
    this.proceedNextStep=false;
    this.newTrendSelect=false;
    this.monthInputValue =null;
    this.dateInputValue = null;
    // this.setLoad=null;
    // this.setProcess = false;
    this.prdNameValue = null;
    // this.dataSource = null;
    this.newTrend=null;
    this.datascrLeng=null;
    // this.daySelectRadio= false;
    // this.monthSelectRadio=false;
    this.eqTrend ='';
    this.loadRadioGroup='';
    this.planDateRadioGroup='';
    this.processnameList='';
    this.loadnameList='';
   
    // this.loads_value = [];
    console.log("loads List: ",this.loadsList);
    this.plannedValue={};
  
  }

 
  


//E/Q Step2 variable list

  //select date
  getLoadByDateChangeLoad(event) {
   
    let dateFormat = moment(new Date(event)).format('YYYY-MM-DD');
    this.dateFormat=dateFormat
    console.log(event,+"   "+dateFormat);
    this.eqBenchmarkingService.getLoadsByQUseFromLiveData(this.siteId,dateFormat).subscribe(data =>{
      console.log("date cahneg: ",data);
    })
  }

  //select load
  getLoadByDate(){

  }

  loadChangestep2(event){
    console.log("event value strem: ",event.source.checked)
    this.load2Status = event.source.checked;
    this.value2StreamStatus=false;
    this.selectedProcessStep2ID=null;
    this.processnameList2='';

  }

  ChangeLoadStep2(event){
    console.log("load change: ",event)
    console.log("selectedLoadStep2",this.selectedLoadStep2ID)
    this.selectedLoadStep2ID = event.value;
    console.log("selectedLoadStep2ID",this.selectedLoadStep2ID)
  }

  //select value stream
  valueStreamChangeStep2(event){
    console.log("event value strem: ",event)
    this.value2StreamStatus=event.source.checked;
    this.load2Status =false;
    this.selectedLoadStep2ID=null;
    this.load2nameList='';
  }

  ChangeProcessStep2(event){
    console.log("process: ",event)
    this.selectedProcessStep2ID=event.value;
    console.log("selectedProcessStep2",this.selectedProcessStep2ID)
  }

  //Shift, Enter Actual Qty, Target Energy
  getShifts(site){
    this.eqBenchmarkingService.getShiftsBySiteId(site).subscribe(data =>{
      console.log("data: ",data);
      this.loadShiftDataObj=[];
      this.loadShiftDataObj=data;
      data.forEach(ele =>{
        this.shiftNameList.push({
          shiftId: ele.shiftId,
          shiftName: ele.shiftName
        })
      })
    })
  }

  actualQuantityInput(event,shiftname,index){
    // this.quantityShiftList=[];
    let quantitylist ={};
    let shiftObj ={};
    // console.log("event,i",event,shiftname,index,this.actualValue)
    console.log("loadsList: ",this.loadsList);
    console.log("this.actualValue",this.actualValue)
    // [{"quantity":10,"shift":{"shiftId":1}}],
    console.log("loadShiftDataObj",this.loadShiftDataObj)
    
    this.loadShiftDataObj.forEach(ele =>{
      if(index == ele.shiftId){
        // quantitylist[]
        quantitylist['quantity'] = this.actualValue[index];
        quantitylist['shift'] = ele;
        this.quantityShiftList.push(quantitylist)
        console.log("ele: ", quantitylist['quantity']);
        console.log("ele: ",quantitylist['shift'] );
        console.log("qutyt: ",quantitylist);
        console.log("inside  this.quantityShiftList: ", this.quantityShiftList)
      }
    })
    console.log("out  this.quantityShiftList: ", this.quantityShiftList)


    // this.loadShiftDataObj.forEach((ele,i) =>{
    //   console.log("i",i+1)
    //   if(shiftname == ele.shiftName ){
    //     // shiftObj
    //     quantitylist[i].push({
    //       quantity: this.actualValue[i+1],
    //       shift:  ""
    //     })

    //     console.log("shiftObj[i]: ",shiftObj[i])
        
    //   }
    // })
    // console.log(" quantitylist: ",  quantitylist)
    
   

  }
  //Submit, Clear and Load buttons

  submitQuantitySettings(){
    this.canDeactiveStatus=true;
    console.log("date: ",this.dateFormat);
    console.log("this.selectedProcessStep2ID: ",this.selectedProcessStep2ID )
    let loadid =[];
    let shifts=[];
    if(this.selectedLoadStep2ID != null){
      console.log("inside load",loadid)
      loadid=[]
      loadid.push(this.selectedLoadStep2ID)
    }
    else if(this.selectedProcessStep2ID != null){
      console.log("inside this.selectedProcessStep2ID:",loadid)
      loadid=[]
      loadid.push(this.selectedProcessStep2ID)
    }
    else{
      console.log("inside else: ",loadid)
      loadid=[];
    }

   console.log(this.actualValue);
    this.loadShiftDataObj.forEach(ele=>{
      if(this.actualValue[ele.shiftId]!=null){
        shifts.push({
          quantity:this.actualValue[ele.shiftId],
          shift:ele
        })
      }
      else {
        shifts.push({
          quantity:null,
          shift:ele
        })
      }
    })
    console.log("shifts: ",JSON.stringify(shifts))
    


    let param = {
      "date":this.dateFormat,
      "loadID":loadid,
      "shiftAndQs":shifts,
      "siteID":this.siteId

    }

    console.log("params:", JSON.stringify(param));
    this.eqBenchmarkingService.saveActualQForLoad(param).subscribe(data =>{
      if(data==true){
        this.alertService.message ="Save successfully!";
        this.alertService.showSuccess();
        this.clear();
      }
      else {
        this.alertService.message ="Failed to save!";
        this.alertService.showError();
      }
    })

  }

  clearQuantitySettings(){
    this.liveDate=null;
    this.actualValue={};
    this.value2StreamStatus=false;
    this.load2Status=false;
    this.selectedLoadStep2ID="";
    this.selectedProcessStep2ID="";
    this.processnameList2='';
    this.loadStreamRadioGroup=null;
    this.loadRadioStatus=false;
    this.streamRadioStatus=false;
    this.load2nameList='';
    

  }

  // canDeactivate function

   
}

export interface PeriodicElement {
  load: string;
  daymonth: string;
  quantity: number;
 
}
export interface EmptyElement{}
//Table element
var ELEMENT_DATA: PeriodicElement[] ;
var Empty_Data: EmptyElement[];



